import { Button, Container, Grid, Paper, Typography } from '@mui/material';


export const SystemLogin = () => {

    return <Container>
        <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12} sm={10} md={8} lg={6} alignSelf='center'>
                <Paper sx={{ padding: 2, textAlign: 'center' }}>
                    <form>
                        <Typography variant='h1' textAlign='center'>Serveur déconnecté de google.</Typography>
                        <Typography variant='body1'>Le serveur ne peut plus avoir accès aux dossiers de projets, et ainsi maintenir l'information à jour avec Google Drive.</Typography>
                        <Typography variant='body1'><strong>Note : </strong>La connexion doit être effectuée avec le compte <strong>serveurcdx@gmail.com</strong> et non votre propre compte googl pour des raisons de sécurité (serveurcdx@gmail.com a uniquement accès en lecture seuls aux documents de projet. Or toute autre tentative de connexion avec un autre compte sera refusé).</Typography>
                        <Typography variant='h2'>Courriel : serveurcdx.com. Mot de passe : Le même que SmartUse !</Typography>
                        <Typography variant='h2'><Button size='large' type="submit" name="submit" value="submit">Connecter le serveur avec servercdx@gmail.com</Button></Typography>
                    </form>
                </Paper>
            </Grid>
        </Grid>
    </Container >;
};
